import { g as gsapWithCSS } from "@theme/theme";
class ProductInfoComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      content: this.querySelector(".js-product-info-content"),
      toggle: this.querySelector(".js-product-info-toggle")
    };
  }
  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    this.DOM.toggle.addEventListener("click", this.toggle.bind(this));
  }
  toggle() {
    this.DOM.content.classList.toggle("is-active");
    this.DOM.toggle.classList.toggle("is-active");
    gsapWithCSS.to(this.DOM.content, {
      duration: 1,
      height: this.DOM.toggle.classList.contains("is-active") ? "auto" : 0,
      ease: "easeInOutStrong"
    });
  }
}
window.customElements.define("c-product-info", ProductInfoComponent);
